<template>
  <div>
    <lateralNavigation2></lateralNavigation2>
    <rightNav></rightNav>
  <div class="shopping-trolley sub-main" style="padding-top: 20px">
    <div class="trolley-list warp">
      <div class="total-pro">
        我的购物车
      </div>
      <div class="trolley-title">
        <p>
          <el-checkbox
            v-model="selectAll"
            @change="getAllProduct"
            :true-label="1"
            :false-label="0"
          />全选
        </p>
        <p><b>商品名称</b></p>
        <p>商品属性</p>
        <p>单价</p>
        <p>数量</p>
        <p>小计</p>
        <p>操作</p>
      </div>
      <div class="trolley-body">
        <div v-if="noGoods == false">
          <div class="main-list" v-for="(it, index) in list" :key="it.id">
            <div class="pro-list">
              <div class="pro-item">
                <div class="item">
                  <el-checkbox
                    v-model="it.selected"
                    @change="selectProduct(it)"
                    :true-label="1"
                    :false-label="0"
                  />
                </div>
                <div class="item">
                  <img
                    :src="it.productInfo.image"
                    alt=""
                    @click="goToProductDetail(it)"
                  />
                  <div class="pro-des">
                    <div>
                      <p @click="goToProductDetail(it)">
                        {{ it.productInfo.storeName }}
                      </p>
                    </div>
                    <p>
                      <span>{{ it.productInfo.attrInfo.sku }}</span>
                    </p>
                    <p class="discounts">限时优惠</p>
                  </div>
                </div>
                <div class="item">
                  <p>¥ {{ it.productInfo.attrInfo.price }}</p>
                </div>
                <div class="item">
                  <el-input-number
                    v-model="it.cartNum"
                    @change="handleChange(it)"
                    :min="1"
                    :max="it.productInfo.stock"
                    :step="1"
                    label="描述文字"
                    size="small"
                  ></el-input-number>
                </div>
                <div class="item">
                  <p>¥ {{ it.productInfo.attrInfo.price }}</p>
                </div>
                <div class="item">
                  <p @click="confirDelete(it,false)" v-throttle>删除</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="noproduct" v-else>
          <img src="../../../static/image/noorder@2x.png" alt="" />
          <p class="fs20 font-color-999">你的购物车还没有宝贝哦～</p>
        </div>

        <div class="trolley-footer">
          <div class="item">
            <el-checkbox
              v-model="selectAll"
              @change="getAllProduct"
              :true-label="1"
              :false-label="0"
            />全选
          </div>
          <div class="item">
            <span
              @click="confirDelete(selectedList, true)"
              class="hover"
              v-throttle
              >删除</span
            >
          </div>
          <div class="item">
            <span>清除失效的宝贝</span>
          </div>
          <div class="item">
            已选商品
            <span>{{ countSelect }}</span>
            件
          </div>
          <div class="item">
            <p>
              合计 (不含运费) :
              <span> ¥ {{ totalProice }}</span>
            </p>
            <p>优惠券: ¥0.00</p>
          </div>
        </div>
      </div>
      <div class="submit-div">
        <div class="submit-button hover" @click="submitOrder" v-throttle>结算</div>
      </div>
    </div>
    <delete-goods
      :delete-opt="deleteOpt"
      @close="closePop"
      v-if="deleteOpt.visiable"
      @confirm="deleteGood"
    />
  </div>
  </div>
</template>

<script>
import { listSearchMixin } from "../../config/mixin";
import api from "@/api";
import CereHeader from "../../components/canvasShow/slwshop/home/header";
import DeleteGoods from "./deleteGoods.vue";
import { mapGetters, mapMutations } from "vuex";
import Cookie from "js-cookie";
import lateralNavigation2 from "../../components/base/lateralNavigation2";
import rightNav from "../../components/canvasShow/rightNav";
import Serve from "../../components/serve/serve";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import detailData from "../product/detailData";
import evaluation from "../product/evaluation";
import likeList from "../product/likeList";
export default {
  components: { CereHeader, DeleteGoods,lateralNavigation2,rightNav },
  mixins: [listSearchMixin],
  data() {
    return {
      deleteOpt: {
        visiable: false,
      },
      selectAll: 0,
      playDiscount: false,
      list: [],
      // 已选择的商品
      selectedList: [],
      count: 0,
      // 商品总价
      totalProice: 0,
      noGoods: false,
    };
  },
  created() {
    if (!Cookie.get("token")) {
      this.$message({
        message: "请先登录",
      });
      this.$router.push({ path: "/login" });
    } else {
      this.getTrolleyList();
      this.getCartCount();
    }
  },
  computed: {
    ...mapGetters(["cartNumber"]),
	//已选中的件数
	countSelect(){
		return this.list.reduce((pre,cur)=> {
			if(cur.selected){
				pre += cur.cartNum
			}
			return pre
		},0)
	},
  },
  methods: {
    ...mapMutations({
      setShoppingCart: "SET_SHOPPINGCART",
      setCartNumber: "SET_CARTNUMBER",
      setCurrentPro: "SET_CURRENTPRO",
    }),
    // 初始化购物车数据
    initList() {
          this.setCartNumber(this.list.length)
    },

    // 购物车总数
     async getCartCount() {
      const rLoading = this.openLoading();
      const vm = this;
      const params = {
        url: api.getCartCount,
        method: "GET",
      };
      vm.sendReq(params, (res) => {
        this.count = res.data.count;
        rLoading.close();
      });
    },

    // 购物车列表
    async getTrolleyList() {
      const rLoading = this.openLoading();
      const vm = this;
      const params = {
        url: api.getTrolleyList,
        method: "GET",
      };
      vm.sendReq(params, (res) => {
        const d = res.data.valid;
        if (res.success) {
          this.noGoods = false;
        } else {
          this.noGoods = true;
        }
          this.list = d.map(item => {
            return {
              "selected":0,
              ...item
            }
          });
          this.setShoppingCart(d);
          this.initList();
        rLoading.close();
      });
    },
    // 选择商品
    selectProduct(data) {
		//全选全不选
    console.log(!this.list.some(item => item.selected == 0));
		this.selectAll = !this.list.some(item => item.selected == 0)
      this.getSelectedProduct(data);
    },

    // 全选
    getAllProduct() {
      this.list.forEach((j) => {
             this.$set(j, 'selected', this.selectAll)
      });

      this.getSelectedProduct();
    },

    // 选择的商品集合
    getSelectedProduct(data) {
        this.getTotalPrice()
    },
    // 计算商品总价
    getTotalPrice() {
      let sum = 0;
      // this.list.forEach((item) => {
      //   console.log(item);
      //   sum += parseInt(item.productInfo.attrInfo.price)*item.cartNum;
      // });
      // this.totalProice = sum;
	  console.log(this.list)
	  // this.list.forEach(item => {
		 //  if(item.selected) {
			//   this.totalProice += item.truePrice * item.cartNum
		 //  }
	  // })
	  this.totalProice = this.list.reduce((pre,cur)=>{
		  if(cur.selected){
			  pre += cur.truePrice * cur.cartNum
		  }
		  return pre
	  },0)

	  this.totalProice = this.totalProice ? this.totalProice : 0

    },
    // 确认是否删除商品
    confirDelete(info, flag) {
      // info.selected =1;
       var ids =[];
       // this.list.forEach((j) => {
       //    if(j.selected==1){
       //      ids.push(j.id)
       //    }
       //  });
	   console.log(this.list)
	   if(flag){
		   this.list.forEach(i=>{
			   if(i.selected == 1)	ids.push(i.id)
		   })
	   }else{
		   ids.push(info.id)
	   }
	   console.log(ids)
	   if(ids.length == 0) return
	   console.log(123)
	   ids.forEach(item=> {
		   console.log(item)
		   this.list.splice(this.list.findIndex(item1=>item1.id == item),1)
	   })
        this.deleteGood(ids);
    },
    // 删除单个商品
    deleteGood(ids) {
      // let ids = [];
      let params;
      // if(this.list.length==1){
      //       ids.push(this.list[0].id)
      // }else{
      //    this.list.forEach((j) => {
      //     if(j.selected){
      //       ids.push(j.id)
      //     }
      //   });
      // }
      params = {
        url: api.deleteGoods,
        method: "post",
        data: {
          ids: ids,
        },
      };
     this.getSelectedProduct()
         this.closePop()
      this.sendReq(params, (res) => {
         this.noGoods = false
         this.$message.success('删除成功')
          this.getTrolleyList();
      });
       this.selectAll = false
    },
    // 修改购物车商品数量
    handleChange(kt) {
      console.log(kt);
      const params = {
        url: api.updateGoodNum,
        method: "POST",
        data: {
          id: kt.id,
          number: kt.cartNum,
        },
      };
      this.sendReq(params, (res) => {
        // console.log(res, 1231)
      });
      this.$set(kt, "total", kt.productPrice * kt.number);
      this.getSelectedProduct();
    },
    // 结算
    submitOrder() {
      let shops = [];
      let cart_ids ="";
      this.list.forEach((j, i) => {
        let valid = [];
        // j.valid.forEach((k, n) => {
        //   if (k.selected) {
        //     valid.push({
        //       skuId: k.skuId,
        //       number: k.number,
        //     });
        //   }
        // });
        if (j.selected==1) {
          valid.push({
            skuId: j.id,
            number: j.cartNum,
          });
		  shops.push({
			  shopId: j.shopId,
			  valid,
			});
		  if(cart_ids==""){
		    cart_ids+=j.id
		  }else{
		    cart_ids+=","+j.id
		  }
        }
        // if (valid.length) {
        //   shops.push({
        //     shopId: j.shopId,
        //     valid,
        //   });
        // }
        // if(cart_ids==""){
        //   cart_ids+=j.id
        // }else{
        //   cart_ids+=","+j.id
        // }
		console.log(j)
      });

	  console.log(cart_ids,shops)
      if (shops.length) {
        return this.$router.push({
          path: "/placeOrder",
          query: {
            type: 2,
            shops: JSON.stringify(shops),
            id:cart_ids
          },
        });
      }
      return this.$message.warning("请至少选中一件商品");
    },
    showDiscount(kt) {
      this.$set(kt, "playDiscount", true);
    },
    hiddenDiscount(kt) {
      this.$set(kt, "playDiscount", false);
    },
    closePop() {
      this.deleteOpt = {
        visiable: false,
      };
    },
    goToProductDetail(item) {
			item.id = item.productId
      this.setCurrentPro(item);
      this.$router.push({path: '/productDetail?productId='+item.storeCode});
    },
    // 跳转到店铺
    toStore(id) {
      this.$router.push({
        path: "/store",
        query: { shopId: id },
      });
    },
  },
};
</script>

<style scoped lang='scss'>
.shopping-trolley {
  width: 80%;
  margin: 20px auto;
  .hover:hover {
    cursor: pointer;
  }
  .trolley-list {
    .total-pro {
      font-size: 20px;
      font-weight: bold;
      color: #0060A5;
      margin-bottom: 20px;
    }

    .trolley-title {
      display: flex;
      font-size: 10px;
      background-color: #f1f2f7;
      height: 27px;
      line-height: 27px;
      background-image: url(../../../static/image/list_titile_bk.gif);
      padding: 0 0px;
      p {
        margin: 0;
        color: #333;
        font-size: 10px;
        flex: 1;
        text-align: center;
        &:nth-child(2) {
          flex: 3;
          text-align: left;
          b {
            font-weight: normal;
            padding-left: 140px;
          }
        }
        &:nth-child(3) {
          padding-left: 10px;
          flex: 1;
          text-align: left;
        }
      }
      >>> .el-checkbox {
        margin-right: 5px;
      }
    }

    .trolley-body {
      margin-top: 10px;
      border-top: 3px solid #aaa;
      .main-list {
        .main-shop {
          color: #333;
          font-size: 16px;
          margin: 20px 0 32px;
          padding-left: 30px;
          .goToStore {
            cursor: pointer;
          }
          .discount {
            color: #ff7800;
            font-size: 14px;
            padding: 8px 9px;
            display: inline-block;
            border: 1px #ff7800 dashed;
            margin-left: 20px;
            position: relative;
            &:hover {
              cursor: pointer;
            }
            .pop-box {
              position: absolute;
              left: 0;
              top: 25px;
              z-index: 2;
              padding-top: 30px;
              .box-content {
                background: #fff;
                padding: 20px;
                border-radius: 4px;
                border: 0.5px #ff7800 solid;
                min-height: 200px;
                min-width: 500px;
                position: relative;
                &::before {
                  position: absolute;
                  content: "";
                  width: 0;
                  height: 0;
                  border-bottom: 12px solid #ff7800;
                  border-left: 8px solid transparent;
                  border-right: 8px solid transparent;
                  top: -13px;
                  left: 25px;
                }
                &::after {
                  position: absolute;
                  content: "";
                  width: 0;
                  height: 0;
                  border-bottom: 11px solid #fff;
                  border-left: 7px solid transparent;
                  border-right: 7px solid transparent;
                  top: -10px;
                  left: 25.5px;
                }
                .title {
                  font-size: 14px;
                  color: #333;
                }
                ul {
                  li {
                    height: 40px;
                    line-height: 40px;
                    margin-top: 20px;
                    // overflow: hidden;
                    p {
                      float: left;
                      &:nth-child(1) {
                        width: 80px;
                        height: 40px;
                        text-align: center;
                        border: 1px solid #fd5b5b;
                        border-radius: 4px;
                        color: #fd5b5b;
                        font-size: 16px;
                        font-weight: bold;
                        box-sizing: border-box;
                      }
                      &:nth-child(2) {
                        span {
                          display: block;
                          line-height: 20px;
                          color: #666;
                          font-size: 14px;
                        }
                      }
                      &:nth-child(3) {
                        width: 80px;
                        height: 40px;
                        text-align: center;
                        color: #fff;
                        font-size: 16px;
                        font-weight: bold;
                        background: #fd5b5b;
                        border-radius: 4px;
                      }
                      &:nth-child(n + 2) {
                        margin-left: 20px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .pro-list {
          border: 1px solid #e5e5e5;
          .pro-item {
            display: flex;
            padding: 36px 0;
            background: #FFFFFF;
            &:nth-child(n + 2) {
              border-top: 1px solid #e5e5e5;
            }
            .item {
              flex: 1;
              p {
                text-align: center;
              }
              &:nth-child(1) {
                display: flex;
                align-items: center;
                justify-content: center;
              }
              &:nth-child(2) {
                p {
                  text-align: left;
                  cursor: pointer;
                }
                flex: 4;
                img,
                .pro-des {
                  float: left;
                }
                img {
                  width: 61px;
                  height: 61px;
                  box-sizing: border-box;
                  cursor: pointer;
                }
                .pro-des {
                  width: calc(100% - 100px);
                  box-sizing: border-box;
                  padding-left: 20px;
                  height: 100%;
                  position: relative;
                  div {
                    p {
                      float: left;
                      overflow: hidden;
                      &:nth-child(1) {
                        width: 80%;
                        color: #333;
                        font-size: 8px;
                        padding-right: 30px;
                        box-sizing: border-box;
                      }
                      &:nth-child(2) {
                        width: 33%;
                       p{
                         span {
                          display: block;
                          font-size: 8px;
                          color: #999;
                        }
                       }
                      }
                    }
                  }
                  p.discounts {
                    position: absolute;
                    bottom: -10px;
                    left: 20px;
                    clear: both;
                    background: #fff2ed;
                    font-size: 10px;
                    color: #ff7800;
                    border-radius: 2px;
                    padding: 2px 7px;
                    display: inline-block;
                  }
                }
              }
              &:nth-child(4) {
                flex: 1;
              }
              &:nth-child(5) {
                color: #ff7800;
                font-weight: bold;
              }
              &:last-child {
                &:hover {
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
      .noproduct {
        width: 100%;
        text-align: center;
        padding: 200px 0;
      }
    }

    .trolley-footer {
      margin: 10px 0 10px;
      background-color: #f1f2f7;
      height: 80px;
      display: flex;
      font-size: 10px;
      align-items: center;
      color: #333;
      .item {
        flex: 1;
        &:nth-child(1) {
          padding-left: 40px;
        }
        &:nth-child(4) {
          span {
            color: #ff7800;
            font-size: 20px;
          }
        }
        &:nth-child(5) {
          flex: 3;
          padding-right: 15px;
          p {
            text-align: right;
            line-height: normal;
            span {
              color: #ff7800;
              font-size: 20px;
            }
          }
        }
        &:nth-child(n-2) {
          line-height: 40px;
        }
        //&:last-child {
        //  width: 100px;
        //  text-align: center;
        //  font-size: 20px;
        //  color: #fff;
        //  background-color: #ff7800;
        //  line-height: 80px;
        //}
        >>> .el-checkbox {
          margin-right: 5px;
        }
      }
    }
  }
  .submit-div {
    float: right;
    margin-bottom: 100px;
  }
  .submit-button {
    width: 80px;
    text-align: center;
    right: 0;
    font-size: 15px;
    color: #fff;
    background-color: #0060A5;
    border-radius: 10px;
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/shopping-trolley/index.vue